import React, {useState} from 'react';
import {Link} from "react-router";
import woman from "../assets/images/thumb/woman-banner.png";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import {toast} from "react-toastify";

function Iletisim(props) {
    const [captcha, setCaptcha] = useState(false)
    const [form, setForm] = useState({
        surename:"",
        name:"",
        phone:"",
        email:"",
        subject:"",
        message:"",
        address:"",
    })
    const sendMail = async (e) => {
        // eslint-disable-next-line no-unused-expressions
        e.preventDefault();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        const {name,email,subject,message} = form;
        if(name && email && subject && message){
            if(captcha){
                try{
                    const res = await axios.post('https://clerksoftware.com/contact2.php', form, { headers: {'Content-Type': 'application/json'}})
                    if(res.data.msg){
                        toast.success(res.data.msg)
                    }
                } catch (err){
                    toast.error('Bir şeyler yanlış.')
                    console.log(err)
                }
            }
        }else{
            toast.warn('Lütfen istenilen alanları doldurunuz!')
        }
    }

    return (
        <React.Fragment>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
          <span className="breadcumb__title">
            İLETİŞİME <span className="breadcumb__title-lighten">GEÇİN</span>
          </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            {" "}
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>{" "}
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">İLETİŞİME GEÇİN</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="contact-wrapper">
                <ul className="contact-img-list">
                    <li className="contact-img-list__item">
                        <img src={woman} alt=""/>
                    </li>
                    <li className="contact-img-list__item">

                    </li>
                </ul>
                <div className="contact-top pt-120 pb-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                <div className="section-heading style-two">
                                    <h2 className="section-heading__title"> BİZİMLE İLETİŞİME GEÇİN</h2>

                                </div>
                                <div className="row gy-5">
                                    <div className="col-sm-6">
                                        <div className="contact-content">
                                            <div className="contact-content__icon">
                                                <span className="icon-pin1"/>
                                            </div>
                                            <div className="contact-content__address">
                                                <h5 className="contact-content__title">Adres</h5>
                                                <p className="contact-content__desc">
                                                    Ayazağa mah Azerbaycan cad 2B No:3K İç Kapı No 13
                                                </p>
                                                <p className="contact-content__desc">Sarıyer/İstanbul, Turkey</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="contact-content">
                                            <div className="contact-content__icon">
                                                <span className="icon-chat"/>
                                            </div>
                                            <div className="contact-content__address">
                                                <h5 className="contact-content__title">E-mail</h5>
                                                <p className="contact-content__desc">
                                                    digital@audiotime.com.tr
                                                </p>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contact-messsage pt-60 pb-120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7">
                                {/* Comment Form Start */}
                                <div className="faq-comment-form mt-lg-5 mt-4 pt-4 pt-lg-2">
                                    <form action="#" autoComplete="off">
                                        <h3 className="comment-form__title">SORULARINIZ İÇİN </h3>
                                        <div className="row gy-md-4 gy-3">
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form--control"
                                                    placeholder="İsim*"
                                                    value={form.name}
                                                    onChange={e=>setForm(prevState => ({...prevState, name:e.target.value}))}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <input
                                                    type="email"
                                                    className="form--control"
                                                    placeholder="Email Adresi*"
                                                    value={form.email}
                                                    onChange={e=>setForm(prevState => ({...prevState, email:e.target.value}))}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <input
                                                    type="text"
                                                    className="form--control"
                                                    placeholder="Telefon numaranızı girin"
                                                    value={form.phone}
                                                    onChange={e=>setForm(prevState => ({...prevState, phone:e.target.value}))}
                                                />
                                            </div>
                                            <div className="col-sm-6">
                                                <input
                                                    type="Adres"
                                                    className="form--control"
                                                    placeholder="Adres Girin"
                                                    value={form.address}
                                                    onChange={e=>setForm(prevState => ({...prevState, address:e.target.value}))}
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <input
                                                    type="Konu"
                                                    className="form--control"
                                                    placeholder="Konuyu yazın"
                                                    value={form.subject}
                                                    onChange={e=>setForm(prevState => ({...prevState, subject:e.target.value}))}
                                                />
                                            </div>
                                            <div className="col-sm-12">

                  <textarea
                      className="form--control"
                      placeholder="Mesajınızı buraya yazın..."
                      defaultValue={""}
                      value={form.message}
                      onChange={e=>setForm(prevState => ({...prevState, message:e.target.value}))}
                  />
                                            </div>
                                            <div className="col-sm-12 justify-content-center">
                                                <ReCAPTCHA
                                                    sitekey="6LeLSGkrAAAAAIxs3YiWcmfqob17yDNJcHwN1p4A"
                                                    onChange={e => setCaptcha(e)}
                                                />
                                            </div>
                                            <div className="col-sm-12">
                                                <button className="btn--base style-two w-100" onClick={sendMail}>
                                                    {" "}
                                                    GÖNDER{" "}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {/* Comment Form End */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="contact-map">
                <iframe
                    className="contact-map__iframe"
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3006.3600137834283!2d28.98443217604539!3d41.10482787133713!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDHCsDA2JzE3LjQiTiAyOMKwNTknMTMuMiJF!5e0!3m2!1sen!2suk!4v1750254862465!5m2!1sen!2suk"
                    width={600}
                    height={450}
                    style={{border: 0}}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"/>
            </div>

        </React.Fragment>
    );
}

export default Iletisim;